"use client"

import { ErrorMessage } from "@/app/error"
import { ProfileBlockchainFilters } from "@/app/profiles/profile-blockchain-filters"
import { reatomComponent } from "@reatom/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import {
  UserBidsTableReatom,
  UserBidsTableSkeleton,
} from "./table/user-bids-table.reatom"

export const UserBidsReatom = reatomComponent(() => {
  return (
    <ErrorBoundary
      fallback={
        <div className="flex h-full flex-col items-center justify-center">
          <ErrorMessage />
        </div>
      }
    >
      <div className="flex flex-wrap items-center gap-4 md:flex-nowrap md:justify-end">
        <ProfileBlockchainFilters />
      </div>
      <Suspense fallback={<UserBidsTableSkeleton />}>
        <UserBidsTableReatom />
      </Suspense>
    </ErrorBoundary>
  )
})
